import React, { useEffect } from 'react';
import { clearLastPath, getParameterByName, toQueryString } from '@shared/utils/UrlUtils';
import AuthWrapper from '../auth/components/AuthWrapper';
import { microsoftClientId } from '@shared/services/EnvironmentVariables';
import { app, authentication } from "@microsoft/teams-js";
import { v4 as uuidv4 } from 'uuid';

export function isOnTeamsTabAuthPage(): boolean {
  const path = window.location.pathname;
  return path === "/login/tab-auth"
    || path === "/login/tab-auth-end"
    || path === "/login/admin-consent"
    || path === "/login/admin-consent-end";
}

export default function LoginWithAzureInTeamsTab() {
  useEffect(() => {
    document.body.style.backgroundColor = '#FAFAFA';
    clearLastPath();
  }, []);

  useEffect(() => {
    if (!authentication) {
      console.log('is not in teams on teams tab page')
      window.close();
      return;
    }


    const processAuth = async () => {
      await app.initialize();
      const context = await app.getContext();
      // Generate random state string and store it, so we can verify it in the callback
      let state = uuidv4(); // _guid() is a helper function in the sample
      localStorage.setItem("simple.state", state);
      localStorage.removeItem("simple.error");
      const scopes = getParameterByName('scopes', window.location.href);

      // Go to the Azure AD authorization endpoint
      let queryParams = {
        client_id: microsoftClientId,
        response_type: "id_token token",
        response_mode: "fragment",
        scope: scopes,
        redirect_uri: window.location.origin + "/login/tab-auth-end",
        nonce: uuidv4(),
        state: state,
        // The context object is populated by Teams; the loginHint attribute
        // is used as hinting information
        login_hint: context.user?.loginHint,
        // Force the consent screen so Entra writes a fresh grant. Needed when
        // silent SSO from the add-in fails because consent isn't recorded for
        // this tenant/user — re-running consent resolves the silent path next
        // time and unblocks the popup flow now.
        prompt: 'consent',
      };

      let authorizeEndpoint = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?${toQueryString(queryParams)}`;
      window.location.assign(authorizeEndpoint);
    }

    processAuth();
  }, []);

  return (
    <AuthWrapper dataTest="login-invite" title="" spinner={true} hideLoginLink={true} hideHeader={true}>
    </AuthWrapper>
  )
}

